
const primary = '#0a93ae';
const tertiary = '#121820';
const fontFamily = '\'Source Sans 3\', \'Segoe UI\', sans-serif';

export const customTheme = {
  token: {
    colorPrimary: primary,
    colorBgContainer: tertiary,
    colorBgBase: '#0b0f14',
    colorText: '#e8eef5',
    colorTextSecondary: '#8b9bb0',
    colorBorder: 'rgba(10, 147, 174, 0.18)',
    colorLink: '#0a93ae',
    colorLinkHover: '#0db8d4',
    fontFamily: fontFamily,
    borderRadius: 6,
  },
  components: {
    Input: {
      borderRadius: 6,
      colorBgContainer: '#161d27',
      colorText: '#e8eef5',
      colorBorder: 'rgba(10, 147, 174, 0.25)',
    },
    Card: {
      borderRadiusLG: 8,
      colorBorder: 'rgba(10, 147, 174, 0.18)',
      colorBgContainer: '#121820',
    },
    Menu: {
      darkItemBg: '#0a6b7d',
      itemBg: '#0a6b7d',
      itemColor: '#e8eef5',
      itemHoverColor: '#ffffff',
      itemSelectedColor: '#ffffff',
      horizontalItemSelectedColor: '#ffffff',
    },
    Layout: {
      headerBg: '#080c10',
      bodyBg: '#0b0f14',
      footerBg: '#080c10',
    },
    Button: {
      borderRadius: 6,
      colorPrimary: '#0a93ae',
    },
  },
};
